const registryFunctionsUrl = "https://itevgnkkwkufjbiuhnlj.supabase.co/functions/v1";

export interface SendSupportEmailPayload {
  subject?: string;
  message: string;
  source?: string;
  level?: "error" | "warning" | "info";
  error?: unknown;
  metadata?: Record<string, unknown>;
  timestamp?: string;
}

export const sendSupportEmail = async (payload: SendSupportEmailPayload) => {
  const registryAnonKey = import.meta.env.VITE_REGISTRY_SUPABASE_ANON_KEY;

  if (!registryAnonKey) {
    throw new Error("Missing VITE_REGISTRY_SUPABASE_ANON_KEY environment variable");
  }

  const response = await fetch(`${registryFunctionsUrl}/send-support-email`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${registryAnonKey}`,
    },
    body: JSON.stringify({
      ...payload,
      timestamp: payload.timestamp ?? new Date().toISOString(),
    }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || "Error sending support email");
  }

  return response.json();
};
